
export const STORAGE = {
	lastActive: "lastActive",
	userType: "userType",
	userData: "userData",
	token: "token",
	userRegisterCycle: "userRegisterCycle",
	viewerProfiles: "viewerProfiles",
};
